import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import ModalService from "src/modals"

import {
  selectBestResearchBuildingLevel,
  selectCurrentTeam,
  selectResearchPoints,
} from "src/store/game"

// The research chip. It reads "🔬 0" forever until someone upgrades a building the game never
// mentions: the Academy and the Evolution Chamber both start at level 0, so no points accrue and
// the whole technology tree sits switched off. Two players went twelve ticks that way in game 9
// without a clue, which is what this says out loud. Requirement 18d.
const ResearchStatus = () => {
  const { t } = useTranslation()
  const points = useSelector(selectResearchPoints)
  const buildingLevel = useSelector(selectBestResearchBuildingLevel)
  const team = useSelector(selectCurrentTeam)

  const buildingName = team === "human" ? t("game.buildings.academy") : t("game.buildings.evolutionChamber")

  // With the building still at level 0 the number cannot move; the chip used to say so beside the
  // count ("0 · sin academia") and the owner asked for the words to go (2026-09-06). The reason
  // stays where it fits, in the tooltip.
  const title =
    buildingLevel === 0 ? t("game.research.noneTitle", { building: buildingName }) : t("game.research.points")

  return (
    <div
      className="stat-chip stat-chip-pressable"
      role="button"
      tabIndex={0}
      onClick={() => ModalService.show("ResearchModal")}
    >
      <p className="resource-extra" title={title}>
        🔬 {points}
      </p>
    </div>
  )
}

export default ResearchStatus
